import React, { Component } from 'react'
import { connect } from 'react-redux';
import { withTranslation } from 'react-i18next';
import { Modal, Checkbox, Collapse, List, message, Radio, Button, Spin } from 'antd';
import { trackDownloadEvent } from "./../../Utils/AnalyticsUtils"
import {
  downloadPricesList,
  setShowPricesListModal,
  getBrandsBySegments
} from '../../actions'

const { Panel } = Collapse;
const FORMAT_EXCEL = 'excel';
const FORMAT_PDF = 'pdf';

class DownloadPricesListModal extends Component {

  getInitialState = () => ({
    selectedItems: [],
    format: FORMAT_EXCEL,
  });

  constructor(props) {
    super(props);
    this.state = this.getInitialState();
  }

  componentDidMount () {
    const { segmentos } = this.props;

    if (!segmentos) {
      this.props.getBrandsBySegments([]);
    }
  }

  handleDownload(format) {
    const { t, downloadPricesList } = this.props;
    const filter = this.state.selectedItems;

    // Check that exists at least one item
    const hasSelectedItems = Object.values(filter).some(array => array.length > 0);

    if (!hasSelectedItems) {
        message.warning(t('Select at least one segment or brand'));
        return;
    }

    trackDownloadEvent(format);
    downloadPricesList(filter, format);
}

  componentDidUpdate(prevProps) {
    if (prevProps.showPricesListModal && !this.props.showPricesListModal) {
      this.setState(this.getInitialState());
    }
  }

  handleModalClose = () => {
    this.props.setShowPricesListModal();
    this.setState(this.getInitialState());
  }

  handleSegmentCheckboxChange(segment, checked) {
    const newSelectedItems = { ...this.state.selectedItems };
    if (checked) {
      newSelectedItems[segment.id] = segment.brands.map(brand => brand.id);
    } else {
      delete newSelectedItems[segment.id];
    }
    this.setState({ selectedItems: newSelectedItems });
  }

  handleBrandCheckboxChange(segmentId, brandId, checked) {
    const newSelectedItems = { ...this.state.selectedItems };
    if (checked) {
      if (!newSelectedItems[segmentId]) {
        newSelectedItems[segmentId] = [];
      }
      newSelectedItems[segmentId].push(brandId);
    } else {
      newSelectedItems[segmentId] = newSelectedItems[segmentId].filter(id => id !== brandId);
      if (newSelectedItems[segmentId].length === 0) {
        delete newSelectedItems[segmentId];
      }
    }
    this.setState({ selectedItems: newSelectedItems });
  }

  renderSegments(segmentos) {
    return (
      <Collapse bordered={true} accordion>
        {
          segmentos.map((segment, index) => (
            <Panel header={
              <Checkbox
                checked={!!this.state.selectedItems[segment.id]}
                onChange={(e) => this.handleSegmentCheckboxChange(segment, e.target.checked)}
              >
                {segment.descripcion.toUpperCase()}
              </Checkbox>
            } key={segment.id}>
              {segment.brands && this.renderBrands(segment.id, segment.brands)}
            </Panel>
          ))
        }
      </Collapse>
    );
  }

  renderBrands(segmentId, brands) {
    return (
      <List
        size="small"
        bordered={false}
        dataSource={brands}
        renderItem={brand => (
          <List.Item key={brand.id}>
            <Checkbox
              checked={this.state.selectedItems[segmentId] && this.state.selectedItems[segmentId].includes(brand.id)}
              onChange={(e) => this.handleBrandCheckboxChange(segmentId, brand.id, e.target.checked)}
            >
              {brand.descripcion}
            </Checkbox>
          </List.Item>
        )}
      />
    );
  }

  render() {
    const { t, isModalOpen, segmentos, downloadingPricesList } = this.props;
    const { format } = this.state

    return (
      <Modal
        title={t('Price list')}
        visible={isModalOpen}
        onCancel={() => this.handleModalClose()}
        footer={
          <div className="pricesList-modal-footer">
            <Radio.Group
              key="format-selector"
              value={format}
              onChange={(e) => this.setState({ format: e.target.value })}
              buttonStyle="solid"
            >
              <Radio.Button value={FORMAT_EXCEL}>{t('Excel')}</Radio.Button>
              <Radio.Button value={FORMAT_PDF}>{t('PDF')}</Radio.Button>
            </Radio.Group>
            <div className="pricesList-modal-button-group">
              <Button key="cancel" onClick={() => this.handleModalClose()} type="secondary">{t('Cancel')} </Button>
              <Button
                  key="download"
                  onClick={() => this.handleDownload(format)}
                  type="primary"
                  disabled={downloadingPricesList}
              >
                  {t('download')}
              </Button>
            </div>
          </div>
        }
      >
        {downloadingPricesList || !segmentos ? <Spin size="large" className="spin-container"/> : (segmentos && this.renderSegments(segmentos))}
      </Modal>
    )
  }
}

const mapDispatchToProps = dispatch => ({
  downloadPricesList: (filter, format) => {
    dispatch(downloadPricesList(filter, format));
  },
  setShowPricesListModal: () => {
    dispatch(setShowPricesListModal());
  },
  getBrandsBySegments: () => {
    dispatch(getBrandsBySegments());
  },
});

const mapStateToProps = ({ catalog }) => {
  const { selectedSegments, downloadingPricesList, showPricesListModal } = catalog;
  const segmentos = selectedSegments && selectedSegments.segmentos ? selectedSegments.segmentos : null;

  return {
    segmentos,
    downloadingPricesList,
    showPricesListModal
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(withTranslation()(DownloadPricesListModal));

